import * as angular from "angular";
import {IController} from "angular";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {DepotsAlerts} from "../../services/depots-alerts.service";
import {DepotsDialogService} from "../../services/depots-dialogs-service.service";
import {DepotsRequests} from "../../services/depots-requests.service";

export class depotDetailsCtrl implements IController {

  depot: any;

  /* @ngInject */
  constructor(private depotsDialogService: DepotsDialogService, private depotsRequests: DepotsRequests, private bringozLoaderService: BringozLoaderService,
              private $log, private depotsAlerts: DepotsAlerts, private $mdSidenav) {

  }

  $onInit() {

  }

  onEditInfo(event) {
    this.depotsDialogService.editDepot(event, this.depot)
      .then((editedDepot) => {
        this.bringozLoaderService.on();
        return this.depotsRequests.updateOne(this.depot.id, editedDepot)
      })
      .then((updatedDepot) => {
        this.depot = updatedDepot;
        this.depotsAlerts.updateSuccess();
      })
      .catch((error) => {
        if (error) {
          this.depotsAlerts.updateError();
          this.$log.error('Failed to edit depot info @depotDetails@onEditInfo', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  toggleSidenav(event) {
    this.$mdSidenav('closeEventsDisabled').toggle();
  }


}

angular
  .module('bringoz.admin.depots')
  .component('depotDetails', {
    bindings: {
      depot: '<'
    },
    template: require('./depot-details.html').default,
    controller: depotDetailsCtrl
  });
